"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overflow = void 0;
var Overflow;
(function (Overflow) {
    Overflow["Hide"] = "u-overflow-hide";
    Overflow["Visible"] = "u-overflow-visible";
    Overflow["Auto"] = "u-overflow-auto";
})(Overflow = exports.Overflow || (exports.Overflow = {}));
//# sourceMappingURL=Overflow.js.map